/* Protees Noir — Boost: upsells and cross-sells in the bag
   1. Bundle nudge   — "Add 2 more tees for 10% OFF" + quick-add picks (uses the automatic bundle discounts)
   2. Free delivery  — when the bag is under the free-shipping line, suggest add-ons that cover the gap
   3. Complete the look — Shopify "complementary" recommendations first, then "related"
*/
(function () {
  'use strict';
  if (window.NoirBoost) return;
  var C = window.NoirConfig || {}, B = C.boost || {};
  if (B.on === false) return;
  var ROOT = (C.root || '/').replace(/\/?$/, '/');
  var FREE = Number(C.free) || 300000;
  var MIN = Math.round((Number(B.min) || 0) * 100);
  var list = function (s) { return String(s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); };
  var GAP = list(B.gap);
  /* bundle offers: [{n, hs:[handles], t:[[qty, pct], ...] ascending, u:'tee'}] */
  var GROUPS = (B.groups || []).map(function (g) {
    var t = list(g.t).map(function (x) { var p = x.split(':'), v = String(p[1] || '').trim().toLowerCase(); return [Number(p[0]), v === 'free' ? 'free' : Number(v)]; })
      .filter(function (x) { return x[0] > 0 && (x[1] === 'free' || x[1] > 0); }).sort(function (a, b) { return a[0] - b[0]; });
    var free = t.length && t[0][1] === 'free';
    return { n: g.n, hs: list(g.hs), t: free ? [t[0]] : t, u: (g.u || 'piece').trim(), free: free };
  }).filter(function (g) { return g.hs.length && g.t.length; });
  function groupOf(handles) {
    for (var i = 0; i < GROUPS.length; i++) for (var k = 0; k < (handles || []).length; k++) if (GROUPS[i].hs.indexOf(handles[k]) > -1) return i;
    return -1;
  }
  /* % offers: highest tier reached. Buy-X-get-1-free offers: number of free pieces earned. */
  function tierFor(g, n) { if (g.free) return Math.floor(n / g.t[0][0]); var p = 0; g.t.forEach(function (x) { if (n >= x[0]) p = x[1]; }); return p; }
  function nextTier(g, n) {
    if (g.free) { var k = g.t[0][0], r = n % k; return (r === 0 && n > 0) ? null : [n + (k - r), 'free']; }
    for (var i = 0; i < g.t.length; i++) if (n < g.t[i][0]) return g.t[i]; return null;
  }
  /* saving for a set of unit prices (in paisa) */
  function saving(g, prices) {
    if (g.free) { var f = tierFor(g, prices.length), sorted = prices.slice().sort(function (a, b) { return a - b; }), s = 0; for (var i = 0; i < f; i++) s += sorted[i]; return s; }
    var pct = tierFor(g, prices.length), sum = prices.reduce(function (a, b) { return a + b; }, 0); return Math.round(sum * pct / 100);
  }
  function offerName(g) { return g.free ? 'Buy ' + (g.t[0][0] - 1) + ' Get 1 FREE' : g.n; }
  window.NoirBundles = { groups: GROUPS, groupOf: groupOf, tierFor: tierFor, nextTier: nextTier, saving: saving, offerName: offerName };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var clean = function (s) { return String(s || '').split('NEWURG')[0].replace(/\s{2,}/g, ' ').trim().toLowerCase(); };
  var money = function (c) { return window.Noir && window.Noir.money ? window.Noir.money(c) : 'Rs.' + Math.round(c / 100).toLocaleString('en-US'); };
  var sized = function (src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; };

  var box = null, tok = 0, last = null, cache = {}, picks = [];

  /* ---------- data ---------- */
  function state() {
    return fetch(ROOT + '?sections=noir-cart-state', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var h = (j && j['noir-cart-state']) || '';
        var m = h.match(/<script[^>]*data-noir-cart-state[^>]*>([\s\S]*?)<\/script>/);
        return m ? JSON.parse(m[1]) : null;
      });
  }
  function products(h) {
    if (!cache[h]) cache[h] = fetch(ROOT + 'collections/' + encodeURIComponent(h) + '/products.json?limit=40', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { return (j && j.products) || []; })
      ['catch'](function () { return []; });
    return cache[h];
  }
  function sizeIdx(p) {
    var o = p.options || [];
    for (var i = 0; i < o.length; i++) if (/size/i.test(o[i].name || o[i])) return i;
    return 0;
  }
  function price(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
    return v ? Math.round(parseFloat(v.price) * 100) : 0;
  }
  function usable(p, inCart) {
    return p && !inCart[p.id] && (p.options || []).length <= 1 && (p.variants || []).some(function (v) { return v.available; });
  }
  function sheet(p) {
    var si = sizeIdx(p), img = p.images && p.images[0] && (p.images[0].src || p.images[0]);
    var v0 = (p.variants || [])[0] || {};
    return {
      id: p.id, t: clean(p.title), u: ROOT + 'products/' + p.handle, img: sized(img, 300),
      cat: p.product_type, type: (p.product_type || '') + ' ' + p.title, p: price(p),
      c: v0.compare_at_price ? Math.round(parseFloat(v0.compare_at_price) * 100) : 0,
      v: (p.variants || []).map(function (v) { return [v.id, v['option' + (si + 1)] || v.title, v.available]; })
    };
  }

  /* ---------- view ---------- */
  function mount() {
    if (box) return box;
    var d = document.getElementById('NoirDrawer'); if (!d) return null;
    var items = d.querySelector('[data-nd-items]'); if (!items) return null;
    box = document.createElement('div');
    box.className = 'nbx'; box.hidden = true; box.setAttribute('aria-live', 'polite');
    items.parentNode.insertBefore(box, items.nextSibling);
    box.addEventListener('click', click);
    return box;
  }
  function tiles(arr) {
    picks = arr;
    return '<div class="nbx-picks">' + arr.map(function (p, i) {
      var img = p.images && p.images[0] && (p.images[0].src || p.images[0]);
      return '<div class="nbx-t" style="--i:' + i + '"><a class="nbx-t__img" href="' + esc(ROOT + 'products/' + p.handle) + '">' + (img ? '<img src="' + esc(sized(img, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="nbx-t__n">' + esc(clean(p.title)) + '</div><div class="nbx-t__p">' + money(price(p)) + '</div>' +
        '<button type="button" class="nbx-t__add" data-nbx-add="' + i + '" aria-label="Add ' + esc(clean(p.title)) + '">+ Add</button></div>';
    }).join('') + '</div>';
  }
  function dots(g, n) {
    var max = g.t[g.t.length - 1][0], h = '', tiers = {};
    if (g.free) { n = n % max === 0 && n > 0 ? max : n % max; }
    g.t.forEach(function (x) { tiers[x[0]] = x[1] === 'free' ? 'FREE' : x[1] + '%'; });
    for (var i = 1; i <= max; i++) h += '<i class="' + (i <= n ? 'is-on' : '') + (tiers[i] ? ' is-tier' : '') + '" data-l="' + (tiers[i] || '') + '"></i>';
    return '<div class="nbx-dots" aria-hidden="true">' + h + '</div>';
  }
  var plural = function (u, n) { return u + (n > 1 ? 's' : ''); };
  function show(html, kind, pop) {
    var b = mount(); if (!b) return;
    b.className = 'nbx nbx--' + kind + (pop && !reduce ? ' is-pop' : '');
    b.innerHTML = html;
    b.hidden = false;
  }
  function hide() { if (box) { box.hidden = true; box.innerHTML = ''; } picks = []; }

  /* ---------- decide ---------- */
  function run(c) {
    if (!mount()) return;
    var items = (c && c.items) || [];
    if (!items.length) { hide(); last = null; return; }
    var t = ++tok;
    var inCart = {}; items.forEach(function (i) { inCart[i.product_id] = 1; });
    state().then(function (st) {
      if (t !== tok || !st) return;
      var total = c.total_price || 0, gap = Math.max(0, FREE - total);
      /* count bundle pieces per offer; cart items come newest first */
      var cnt = GROUPS.map(function () { return 0; }), newest = {}, order = [];
      (st.items || []).forEach(function (it) {
        var g = groupOf(it.h); if (g < 0) return;
        cnt[g] += it.q;
        if (!(g in newest)) { newest[g] = it.h; order.push(g); }
      });
      var prev = last; last = cnt.slice();
      var unlockedIn = function (g) { return !!prev && tierFor(GROUPS[g], cnt[g]) > tierFor(GROUPS[g], prev[g] || 0); };
      /* nudge the newest offer that still has a next tier; otherwise celebrate the newest maxed one */
      var gi = -1, maxed = -1;
      order.forEach(function (g) { if (gi < 0 && nextTier(GROUPS[g], cnt[g])) gi = g; if (maxed < 0 && !nextTier(GROUPS[g], cnt[g])) maxed = g; });
      if (gi < 0 && maxed > -1) {
        var gm = GROUPS[maxed], pm = tierFor(gm, cnt[maxed]);
        var title = gm.free ? (pm > 1 ? pm + ' FREE ' + plural(gm.u, 2) + ' unlocked' : '1 FREE ' + gm.u + ' unlocked') : pm + '% bundle discount applied';
        var sub = gm.free ? offerName(gm) + ' · ' + esc(gm.n) + ' — the free one comes off automatically.' : esc(gm.n) + ' · you have ' + cnt[maxed] + ' ' + plural(gm.u, cnt[maxed]) + ' in your bag — maximum savings unlocked.';
        show('<div class="nbx-head"><span class="nbx-ic nbx-ic--ok">✓</span><div><b>' + title + '</b><small>' + sub + '</small></div></div>' + dots(gm, cnt[maxed]), 'max', unlockedIn(maxed));
        return;
      }
      if (gi > -1) {
        var g = GROUPS[gi], e = cnt[gi], nt = nextTier(g, e), need = nt[0] - e, have = tierFor(g, e);
        var big = g.free ? (need === 1 ? 'Add 1 more ' + g.u + ' — it’s FREE' : 'Add ' + need + ' more ' + plural(g.u, need) + ' → 1 FREE') : 'Add ' + need + ' more ' + plural(g.u, need) + ' → ' + nt[1] + '% OFF';
        var head = '<div class="nbx-head"><span class="nbx-ic' + (g.free ? ' nbx-ic--gift' : '') + '">' + (g.free ? 'FREE' : '%') + '</span><div><b>' + big + '</b><small>' + esc(g.free ? offerName(g) + ' · ' + g.n : g.n) + ' · ' +
          (have ? (g.free ? have + ' free already · ' : have + '% is already applied · ') : '') + 'applies automatically' + (gap > 0 ? ' · ' + money(gap) + ' to free delivery' : ' · free delivery unlocked') + '</small></div></div>' + dots(g, e);
        var hs = [];
        (newest[gi] || []).forEach(function (h) { if (g.hs.indexOf(h) > -1 && hs.indexOf(h) < 0) hs.push(h); });
        g.hs.forEach(function (h) { if (hs.indexOf(h) < 0) hs.push(h); });
        show(head + '<div class="nbx-load"><i></i><i></i><i></i></div>', 'bundle', unlockedIn(gi));
        Promise.all(hs.slice(0, 2).map(products)).then(function (ls) {
          if (t !== tok) return;
          var seen = {}, out = [];
          ls.forEach(function (l) { l.forEach(function (p) { if (!seen[p.id] && usable(p, inCart) && price(p) >= MIN) { seen[p.id] = 1; out.push(p); } }); });
          show(head + (out.length ? tiles(out.slice(0, 3)) : ''), 'bundle', unlockedIn(gi));
        });
        return;
      }
      if (gap > 0 && GAP.length) {
        var head2 = '<div class="nbx-head"><span class="nbx-ic nbx-ic--ship">→</span><div><b>' + money(gap) + ' away from FREE delivery</b><small>Add one of these and save the ' + money(Number(C.fee) || 25000) + ' delivery fee</small></div></div>';
        show(head2 + '<div class="nbx-load"><i></i><i></i><i></i></div>', 'gap', false);
        Promise.all(GAP.map(products)).then(function (ls) {
          if (t !== tok) return;
          var seen = {}, all = [];
          ls.forEach(function (l) { l.forEach(function (p) { if (!seen[p.id] && usable(p, inCart)) { seen[p.id] = 1; all.push(p); } }); });
          var over = all.filter(function (p) { return price(p) >= gap; }).sort(function (a, b) { return price(a) - price(b); });
          var under = all.filter(function (p) { return price(p) < gap; }).sort(function (a, b) { return price(b) - price(a); });
          var out = over.concat(under).slice(0, 3);
          if (!out.length) { hide(); return; }
          show(head2 + tiles(out), 'gap', false);
        });
        return;
      }
      hide();
    })['catch'](function () { if (t === tok) hide(); });
  }

  /* ---------- actions ---------- */
  function click(e) {
    var b = e.target.closest('[data-nbx-add]'); if (!b) return;
    var p = picks[Number(b.getAttribute('data-nbx-add'))]; if (!p || !window.Noir) return;
    var avail = (p.variants || []).filter(function (v) { return v.available; });
    if (avail.length === 1 && (p.variants || []).length === 1) {
      b.disabled = true; b.textContent = '…';
      window.Noir.cart.add(avail[0].id).then(function (r) {
        var k = r && r.items && r.items[0] && r.items[0].key;
        return window.Noir.drawer.refresh(k);
      })['catch'](function (err) { b.disabled = false; b.textContent = '+ Add'; alert((err && err.description) || 'Sold out'); });
      return;
    }
    window.Noir.sheet.open(sheet(p), null, true);
  }

  /* ---------- complete the look: complementary first ---------- */
  function patchLook() {
    var D = window.Noir && window.Noir.drawer; if (!D || D._nbx) return;
    D._nbx = true;
    var orig = D.loadUpsell;
    D.loadUpsell = function (pid, items) {
      var self = this;
      if (self.upsCache[pid] || B.complementary === false) return orig.call(self, pid, items);
      fetch(ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=complementary', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var comp = (j && j.products) || [];
          if (comp.length >= 2) { self.upsCache[pid] = comp; }
          orig.call(self, pid, items);
        })['catch'](function () { orig.call(self, pid, items); });
    };
  }

  function boot() {
    if (!window.Noir) { setTimeout(boot, 120); return; }
    window.NoirBoost = { run: run };
    patchLook();
    mount();
    document.addEventListener('noir:cart', function (e) { run(e.detail); });
    if (window.Noir.cart.state) run(window.Noir.cart.state);
  }
  window.NoirBoost = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
